import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  AiOutlineHome,
  AiOutlinePicture,
  AiOutlineCamera,
  AiOutlineBell,
  AiOutlineUser,
} from 'react-icons/ai';
import './BottomNav.css';

// Mobile-only bottom tab bar (see AppLayout.css's 768px breakpoint) — replaces the
// hamburger + slide-in sidebar drawer on small screens, matching the reference app's nav.
const BottomNav = ({ onOpenCamera }) => {
  const itemClass = ({ isActive }) => `bn-item${isActive ? ' bn-item--active' : ''}`;

  return (
    <nav className="bottom-nav">
      <NavLink to="/" end className={itemClass}>
        <AiOutlineHome size={22} />
        <span>Home</span>
      </NavLink>

      <NavLink to="/projects" className={itemClass}>
        <AiOutlinePicture size={22} />
        <span>Projects</span>
      </NavLink>

      <button className="bn-item bn-item--camera" onClick={() => onOpenCamera()} aria-label="Capture photos">
        <span className="bn-camera-circle">
          <AiOutlineCamera size={22} />
        </span>
      </button>

      <NavLink to="/notifications" className={itemClass}>
        <AiOutlineBell size={22} />
        <span>Alerts</span>
      </NavLink>

      <NavLink to="/profile" className={itemClass}>
        <AiOutlineUser size={22} />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
